import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { kMediaQuery } from "../../../Admin/kReusableCoreTS/kMediaQuery";
/** Browser query reader; fallback and reporting belong to each enclosing caller. */
export class AppMediaQuery {
    public static Matches = (Query: string): boolean => {
        // DOCUMENTED EXCEPTION: callers own gates and error boundaries. A thrown
        // probe must reach them: coarse typing is conservative, while a failed
        // sheet probe must abort closing instead of treating failure as narrow.
        return kMediaQuery.Matches(Query);
    };
    public static IsCoarse = (FaultName: string): boolean => {
        if (getCoreUtils().KErrorMode === true) { return true; }
        try { return AppMediaQuery.Matches("(pointer: coarse)"); }
        catch (e) { getCoreUtils().KGlobalErrorHandler(e, FaultName); return true; }
    };}
